import React from 'react';

require('../../css/components/ComprehensionQuestion.scss');

'use strict';

export default class ComprehensionQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = { selectedAnswer: this.props.selectedAnswer };

        this.changeSelectedAnswer = this.changeSelectedAnswer.bind(this);
    }

    componentDidMount() {
        if (this.props.question && this.props.answers)
            if (this.props.onQuestionAsked)
                this.props.onQuestionAsked();
    }

    changeSelectedAnswer(event) {
        this.setState({ selectedAnswer: event.target.value });

        if (event.target.value === this.props.correctAnswer.toString()) {
            if (this.props.onQuestionAnsweredCorrectly)
                this.props.onQuestionAnsweredCorrectly();
        }
        else {
            if (this.props.onQuestionAnsweredIncorrectly)
                this.props.onQuestionAnsweredIncorrectly();
        }
    }

    render() {
        if (this.props.question && this.props.answers) {
            var question;
            var answers = [];
            var i;
            var copy = this.props.copy || {};

            if (typeof this.state.selectedAnswer === 'undefined') {
                question = this.props.question;

                answers.push(
                    React.createElement(
                        'div',
                        { className: "comprehension-question-answer-heading" },
                        copy.questionAnswerHeading
                    )
                );

                for (i in this.props.answers)
                    answers.push(
                        React.createElement(
                            'div',
                            { className: "comprehension-question-answer" },
                            [
                                React.createElement(
                                    'input',
                                    { type: "radio", id: "answer-" + i, name: "answer", value: i, onChange: this.changeSelectedAnswer }
                                ),
                                React.createElement(
                                    'label',
                                    { for: "answer-" + i },
                                    this.props.answers[i]
                                )
                            ]
                        )
                    );
            }

            question = React.createElement(
                'div',
                { className: "comprehension-question" },
                [
                    React.createElement(
                        'div',
                        { className: "comprehension-question-heading" },
                        [
                            React.createElement(
                                'span',
                                {},
                                [
                                    copy.questionHeadingBlack
                                ]
                            ),
                            " ",
                            React.createElement(
                                'span',
                                { className: "blue" },
                                [
                                    copy.questionHeadingBlue
                                ]
                            )
                        ]
                    ),
                    React.createElement(
                        'div',
                        { className: "comprehension-question-body" },
                        typeof this.state.selectedAnswer !== 'undefined' ?
                            React.createElement(
                                'div',
                                { className: "comprehension-question-answer-feedback" },
                                this.props.answerFollowup ?
                                    this.props.answerFollowup() :
                                    this.state.selectedAnswer === this.props.correctAnswer.toString() ? copy.questionCorrectAnswerFeedback : copy.questionIncorrectAnswerFeedback
                            ) :
                            [
                                React.createElement(
                                    'div',
                                    { className: "comprehension-question-left" },
                                    question
                                ),
                                React.createElement(
                                    'div',
                                    { className: "comprehension-question-right" },
                                    answers
                                )
                            ]
                    )
                ]
            );

            return question;
        }
        else
            return null;
    }
}